import { DEFAULT_REGION_NAME } from '../../constants/region';
import { IApplicationState } from '../../types/redux';

export function selectLocationName(state: IApplicationState) {
  return state.buildersProjects.data.location?.name || DEFAULT_REGION_NAME;
}
